$ = require('jquery')

DisableAllDirective = ->
  restrict: 'A'
  link:(scope, elem, attrs) ->
    $element = $(elem)
    scope.$watch attrs.gnpDisableAll, (value) ->
      $element.find('input, select, textarea, button').prop("disabled", value)

module.exports = DisableAllDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/form/disable-all-directive.coffee